/* eslint-disable */
import * as util from "@/api/birthdayGreetings";

const state = {
    isShowForm: false,
    formParamSRSt: {
        header: {
            copy: false,
            id: "",
            license_id: "",
            message: "",
            image_url: "",
            is_enable_attach_file: false,
            is_custom_url: false,
            message_type: "text",
        },
    },
};

const mutations = {
    SET_isShowForm: (state, value) => {
        state.isShowForm = value
    },
    SET_formParamSRSt: (state, value) => {
        state.formParamSRSt = value
    },

};

const actions = {
    storedIsEnable({ commit }, params) {
        return new Promise((resolve, reject) => {
            util.storedIsEnable(params).then(response => {
                resolve(response);
            }).catch(error => {
                reject(error);
            });
        });
    },
    storedSetTime({ commit }, params) {
        return new Promise((resolve, reject) => {
            util.storedSetTime(params).then(response => {
                resolve(response);
            }).catch(error => {
                reject(error);
            });
        });
    },
    detailStatus({ commit }, params) {
        return new Promise((resolve, reject) => {
            util.detailStatus(params).then(response => {
                resolve(response);
            }).catch(error => {
                reject(error);
            });
        });
    },
    actionPublish({ commit }, params) {
        return new Promise((resolve, reject) => {
            util.actionPublish(params).then(response => {
                resolve(response);
            }).catch(error => {
                reject(error);
            });
        });
    },
    actionDelete({ commit }, params) {
        return new Promise((resolve, reject) => {
            util.actionDelete(params).then(response => {
                resolve(response);
            }).catch(error => {
                reject(error);
            });
        });
    },
    actionDraft({ commit }, params) {
        return new Promise((resolve, reject) => {
            util.actionDraft(params).then(response => {
                resolve(response);
            }).catch(error => {
                reject(error);
            });
        });
    },
    detailForEdit({ commit }, params) {
        return new Promise((resolve, reject) => {
            util.detailForEdit(params).then(response => {
                resolve(response);
            }).catch(error => {
                reject(error);
            });
        });
    },

    deleteData({ commit }, params) {
        return new Promise((resolve, reject) => {
            util.deleteData(params).then(response => {
                resolve(response);
            }).catch(error => {
                reject(error);
            });
        });
    },
    detail({ commit }, params) {
        return new Promise((resolve, reject) => {
            util.detail(params).then(response => {
                resolve(response);
            }).catch(error => {
                reject(error);
            });
        });
    },
    updatePublish({ commit }, params) {
        return new Promise((resolve, reject) => {
            util.updatePublish(params).then(response => {
                resolve(response);
            }).catch(error => {
                reject(error);
            });
        });
    },
    updateDraft({ commit }, params) {
        return new Promise((resolve, reject) => {
            util.updateDraft(params).then(response => {
                resolve(response);
            }).catch(error => {
                reject(error);
            });
        });
    },
    stored({ commit }, params) {
        return new Promise((resolve, reject) => {
            util.stored(params).then(response => {
                resolve(response);
            }).catch(error => {
                reject(error);
            });
        });
    },
    actFormParamSRSt({ commit }, data) {
        commit("SET_formParamSRSt", data);
    },
    list({ commit }, params) {
        return new Promise((resolve, reject) => {
            util.list(params).then(response => {
                resolve(response);
            }).catch(error => {
                reject(error);
            });
        });
    },
    actFormParamSt({ commit }, data) {
        commit("SET_formParamSt", data);
    },
    setIsShowForm({ commit }, data) {
        // console.log("xxxx",data)
        commit("SET_isShowForm", data);
    },
};


export default {
    namespaced: true,
    state,
    mutations,
    actions
};



// WEBPACK FOOTER //
// ./src/store/modules/birthdayGreetings.js